import { Directive } from '@angular/core';
import { Observable } from 'rxjs';
import { FormConstructorContent } from 'src/app/interfaces/form-and-field.interface';
import { SocialInitiativeChange } from './social-initiative-change.abstract';

@Directive()
export abstract class SocialInitiativeCreation<TFormModel extends object> extends SocialInitiativeChange<TFormModel> {
  public abstract readonly formContent$: Observable<FormConstructorContent>;

  protected abstract fetchAttributeMetadata(): void;
}
